module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./AgentRegisterView.js"));
	}, "AgentRegisterView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AgentRegisterView!./src/pages/Shop/Member/Personal/AgentRegister/AgentRegisterView.js
// module id = 1101
// module chunks = 431